import React, { Component } from 'react';
import history from '../../history';
import moment from 'moment';
import 'moment-timezone';

export class VoteBanner extends Component {
    navigateToVoting = () => {
        history.push('/dashboard/premiumvoting');
    };

    isWeekendBonusActive = () => {
        const now = moment().tz('UTC');
        const dayOfWeek = now.day(); // 0 is Sunday, 6 is Saturday
        return dayOfWeek === 0 || dayOfWeek === 5 || dayOfWeek === 6;
    };

    render() {
        // Temporarily force to true to preview the design
        const isWeekend = this.isWeekendBonusActive();

        return (
            <div className={`relative overflow-hidden ${isWeekend ? 'bg-[#1a0f2a]' : 'bg-[#0f1a2a]'} p-6 sm:p-12 rounded-2xl my-4 text-white`}>
                {/* Dark gradient overlay */}
                <div className={`absolute inset-0 bg-gradient-to-r ${isWeekend ? 'from-[#1a0f2a] via-[#2a1538] to-[#1a0f2a]' : 'from-[#0f1a2a] via-[#152238] to-[#0f1a2a]'}`} />

                {/* Enhanced Glow Effects - Purple for weekend, Blue for normal */}
                {isWeekend ? (
                    <>
                        <div className="absolute -bottom-32 right-0 w-2/3 h-[150%] bg-gradient-to-tl from-[#ff00ff]/30 via-[#9900ff]/20 to-transparent blur-3xl animate-pulse" />
                        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-[#ff00ff]/25 via-[#9900ff]/15 to-transparent blur-2xl animate-pulse" />
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#ff00ff]/[0.05] to-[#9900ff]/[0.08]" />

                        {/* Weekend Multiplier Badge */}
                        <div className="absolute -right-12 -top-12 w-48 h-48 rotate-12">
                            <div className="absolute inset-0 bg-gradient-to-br from-[#ff00ff] to-[#9900ff] rounded-full opacity-20 animate-pulse"></div>
                            <div className="absolute inset-2 bg-gradient-to-br from-[#ff00ff] to-[#9900ff] rounded-full opacity-20 animate-pulse delay-100"></div>
                            <div className="absolute inset-4 bg-gradient-to-br from-[#ff00ff] to-[#9900ff] rounded-full opacity-20 animate-pulse delay-200"></div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="absolute -bottom-32 right-0 w-2/3 h-[150%] bg-gradient-to-tl from-[#00c2ff]/30 via-[#0099ff]/20 to-transparent blur-3xl" />
                        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-[#00c2ff]/25 via-[#0099ff]/15 to-transparent blur-2xl" />
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#00c2ff]/[0.05] to-[#0099ff]/[0.08]" />
                    </>
                )}

                <div className="flex flex-col lg:flex-row items-center justify-between relative z-10 gap-8 lg:gap-0">
                    {/* Content */}
                    <div className="relative z-10 w-full lg:max-w-xl">
                        <div className="flex items-center gap-4 mb-3">
                            <h1 className="text-3xl sm:text-4xl font-bold">
                                Vote for GhostBuddy
                            </h1>
                            {isWeekend && (
                                <div className="animate-bounce">
                                    <span className="inline-flex items-center px-4 py-1 rounded-full text-lg font-bold bg-gradient-to-r from-[#ff00ff] to-[#9900ff] text-white shadow-lg shadow-purple-500/30">
                                        2x BONUS ACTIVE!
                                    </span>
                                </div>
                            )}
                        </div>

                        <div className={`text-2xl font-bold mb-3 ${isWeekend ? 'bg-clip-text text-transparent bg-gradient-to-r from-[#ff00ff] to-[#9900ff]' : 'bg-clip-text text-transparent bg-gradient-to-r from-[#00c2ff] to-[#0099ff]'}`}>
                            {isWeekend ? 'WEEKEND BONUS: Double Premium Rewards!' : 'Earn Premium Rewards'}
                        </div>

                        <p className="text-base sm:text-lg leading-relaxed text-gray-300 mb-5 lg:pr-12">
                            {isWeekend ? (
                                <>Support GhostBuddy by voting on top.gg! This weekend, each vote counts as <span className="font-bold text-[#ff00ff]">2 votes</span>! Collect <span className="font-bold text-[#ff00ff]">10 votes</span> to earn a <span className="font-bold text-[#ff00ff]">5-day premium code</span>.</>
                            ) : (
                                <>Support GhostBuddy by voting on top.gg! Collect <span className="font-bold text-[#00c2ff]">10 votes</span> to earn a <span className="font-bold text-[#00c2ff]">5-day premium code</span>. Visit our Premium Voting page to track your progress and redeem rewards.</>
                            )}
                        </p>

                        <div className="flex flex-col gap-2">
                            <div className="flex gap-4">
                                <a
                                    href="https://top.gg/bot/1331245032568524861/vote"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="relative w-full sm:w-auto px-8 py-3 rounded-lg font-semibold overflow-hidden
                                        transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 
                                        group cursor-pointer"
                                >
                                    {/* Gradient background */}
                                    <div className={`absolute inset-0 bg-gradient-to-r ${isWeekend ? 'from-[#ff00ff] via-[#9900ff] to-[#ff00ff]' : 'from-[#00c2ff] via-[#0099ff] to-[#00c2ff]'}
                                        group-hover:opacity-90 transition-opacity`} />

                                    {/* Shine effect */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent 
                                        translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

                                    {/* Button shadow */}
                                    <div className={`absolute inset-0 shadow-xl ${isWeekend ? 'shadow-[#ff00ff]/20' : 'shadow-[#00c2ff]/20'}`} />

                                    {/* Button text */}
                                    <span className="relative z-10 flex items-center justify-center gap-2">
                                        {isWeekend ? '2x Vote Now!' : 'Vote Now'}
                                    </span>
                                </a>

                                <button
                                    onClick={this.navigateToVoting}
                                    className="relative w-full sm:w-auto px-8 py-3 rounded-lg font-semibold overflow-hidden
                                        transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 
                                        group cursor-pointer bg-[#6B7280] text-white"
                                >
                                    {/* Gradient background */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-[#4B5563] via-[#6B7280] to-[#4B5563] 
                                        group-hover:opacity-90 transition-opacity" />

                                    {/* Shine effect */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent 
                                        translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

                                    {/* Button shadow */}
                                    <div className="absolute inset-0 shadow-xl shadow-gray-500/20" />

                                    {/* Button text */}
                                    <span className="relative z-10 flex items-center gap-2 text-white">
                                        View Rewards
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Promo Image - Hidden on mobile */}
                    <div className="hidden lg:block relative z-10 w-[150px] mr-16">
                        <div className={`animate-bounce ${isWeekend ? 'glow-purple' : ''}`}>
                            <img
                                src="https://cdn.discordapp.com/avatars/1331245032568524861/a_5759d91dea4421eeed8447ae2c4192f2.gif"
                                alt="GhostBuddy Bot"
                                className={`w-full h-auto transform hover:scale-105 transition-transform duration-500 rounded-full ${isWeekend ? 'border-4 border-[#ff00ff]/50' : ''}`}
                            />
                            {isWeekend && (
                                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-[#ff00ff] to-[#9900ff] rounded-full px-3 py-1 text-sm font-bold text-white shadow-lg shadow-purple-500/30 animate-pulse">
                                    2x
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Floating stars decoration */}
                <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-20">
                    {isWeekend ? (
                        <>
                            <div className="absolute top-2 right-[5%] text-[#ff00ff]/30 text-3xl animate-pulse delay-100">✦</div>
                            <div className="absolute top-16 right-[15%] text-[#9900ff]/40 text-2xl animate-pulse delay-300">✧</div>
                            <div className="absolute top-4 right-[25%] text-[#ff00ff]/30 text-3xl animate-pulse delay-500">✦</div>
                            <div className="absolute top-20 right-[35%] text-[#9900ff]/40 text-2xl animate-pulse delay-700">✧</div>
                        </>
                    ) : (
                        <>
                            <div className="absolute top-2 right-[5%] text-white/30 text-3xl animate-pulse delay-100">✦</div>
                            <div className="absolute top-16 right-[15%] text-white/40 text-2xl animate-pulse delay-300">✧</div>
                            <div className="absolute top-4 right-[25%] text-white/30 text-3xl animate-pulse delay-500">✦</div>
                            <div className="absolute top-20 right-[35%] text-white/40 text-2xl animate-pulse delay-700">✧</div>
                        </>
                    )}
                </div>

                <style jsx>{`
                    .glow-purple {
                        filter: drop-shadow(0 0 10px rgba(255, 0, 255, 0.3));
                    }
                `}</style>
            </div>
        );
    }
}

export default VoteBanner; 